import {CSSProperties, ReactElement} from "react";

export const LGBTButton = ({colors=["#F6503C","#E8AA18","#96C833","#318FC2","#10406E"], text="", children=null,textColor="white", textSize="14px",textWeight="400", isBorder=false, onClick}:
                               {colors?:string[],text?:string,children?:ReactElement|null,textColor?:string,textSize?:string,textWeight?:string,isBorder?:boolean,onClick:()=>void}) =>{
    function getButtonProp(){
        if(!isBorder){
            return {...defaultProps, backgroundImage:"linear-gradient(to right,"+ colors.join(",")+")"}
        }else {
            return {...defaultProps, background:"linear-gradient(white 0 0) padding-box, linear-gradient(to right, "+colors.join(",")+") border-box",
                border: "1px solid transparent"}
        }
    }

    const defaultProps:CSSProperties={
        borderRadius:"8px",
        color:textColor,
        paddingTop:"10px",
        paddingBottom:"10px",
        textAlign:"center",
        fontSize:textSize,
        fontWeight:textWeight,
        textTransform:"uppercase",
        cursor:"pointer"
    }


    return(
        <div style={getButtonProp()} onClick={onClick}>
            {children!=null?children:text}
        </div>
    )
}